import { useMutation, useQuery } from "react-query";

import { Sublot } from "../types";
import { handleBasicFetch, handleSave } from "./handler";
import queryClient from "./queryClient";

const methods = {
  useCreateSublotInSublotGroup: ({
    sublotGroupId,
    lotNum,
    numOfAcres,
  }: {
    sublotGroupId?: number;
    lotNum: string;
    numOfAcres: number;
  }) => {
    return useMutation<Sublot>({
      mutationFn: () =>
        handleSave({
          baseUrl: `sublot_groups/${sublotGroupId}/create_sublot`,
          input: {
            num: lotNum,
            numOfAcres,
          },
        }),
    });
  },
  useRemainingAcres: ({ sublotGroupId }: { sublotGroupId?: number }) => {
    return useQuery<{ lotAcres: number; remainingAcres: number }>({
      enabled: !!sublotGroupId,
      queryKey: ["remainingAcres", sublotGroupId],
      queryFn: () =>
        handleBasicFetch({
          url: `sublot_groups/${sublotGroupId}/remaining_acres`,
          params: [],
        }),
    });
  },
};

export default methods;
